/* Make It Lab - keeps shipping, financing and review-count copy consistent site-wide.
   Free shipping applies to TRANSFER orders of $100+. Financing options: Klarna, Affirm and Clicklease. Google reviews: 522.
   Temporary patch for text that lives in files too large to edit from here (index.json, dtf-transfers-v2, same-day-v2, xtool templates).
   Remove once that text is edited in the theme editor.
   A MutationObserver fixes text the moment a script inserts it (before the next paint), so the old numbers never flash. */
(function () {
  var MAP = [
    [/Free shipping on orders over \$99/g, 'Free shipping on transfers $100+'],
    [/Free shipping over \$99/g, 'Free shipping on transfers $100+'],
    [/Klarna and Clicklease/g, 'Klarna, Affirm and Clicklease'],
    [/Klarna for smaller purchases and Clicklease for equipment/g, 'Klarna or Affirm for smaller purchases and Clicklease for equipment'],
    [/Pay Over Time with Klarna(?!,| or)/g, 'Pay Over Time with Klarna, Affirm or Clicklease'],
    [/\b515 (Google )?reviews/g, '522 $1reviews']
  ];
  var KEYS = ['$99', 'Klarna', '515'];
  function fix(t) {
    var v = t.nodeValue;
    for (var i = 0; i < KEYS.length; i++) {
      if (v.indexOf(KEYS[i]) > -1) {
        var o = v;
        MAP.forEach(function (m) { v = v.replace(m[0], m[1]); });
        if (v !== o) t.nodeValue = v;
        return;
      }
    }
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fix(root); return; }
    if (root.nodeType !== 1) return;
    var tg = root.nodeName;
    if (tg === 'SCRIPT' || tg === 'STYLE') return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) hits.push(n);
    hits.forEach(fix);
  }
  function run() { try { walk(document.body); } catch (e) {} }
  try {
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (r.type === 'characterData') fix(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) walk(r.addedNodes[j]);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { mo.disconnect(); }, 12000);
  } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { setTimeout(run, 1200); });
})();